/** Traductions modal validation produits (FR / AR) */
export const productValidationModalFr = {
  successSaveProduct: 'Produit sauvegardé avec succès',
  errStillInvalid: 'Le produit n\'est toujours pas valide',
  successRemoveProduct: 'Produit supprimé',
  errStillInvalidCount: '{{count}} produits ne sont toujours pas valides',
  statusValid: 'Valide',
  statusInvalid: 'Non valide',
  title: 'Validation des Produits',
  progress: 'Progrès',
  noNameProduct: 'Produit sans nom',
  skuLabel: 'SKU',
  skuNotSpecified: 'Non spécifié',
  categoryLabel: 'Catégorie',
  subcategoryLabel: 'Sous-catégorie',
  typeLabel: 'Type',
  priceLabel: 'Prix',
  validationErrors: 'Erreurs de validation',
  warnings: 'Avertissements',
  editProductTitle: 'Modifier le Produit',
  productNameLabel: 'Nom du Produit',
  unitLabel: 'Unité',
  unitPriceLabel: 'Prix Unitaire',
  sellingPriceLabel: 'Prix de Vente',
  cancel: 'Annuler',
  save: 'Sauvegarder',
  editBtn: 'Modifier',
  deleteBtn: 'Supprimer',
  skipBtn: 'Ignorer',
  validating: 'Validation...',
  finishBtn: 'Terminer',
  skipAllInvalid: 'Ignorer tous les produits non valides'
};

export const productValidationModalAr = {
  successSaveProduct: 'تم حفظ المنتج بنجاح',
  errStillInvalid: 'المنتج لا يزال غير صالح',
  successRemoveProduct: 'تم حذف المنتج',
  errStillInvalidCount: 'لا يزال {{count}} منتج غير صالح',
  statusValid: 'صالح',
  statusInvalid: 'غير صالح',
  title: 'التحقق من المنتجات',
  progress: 'التقدم',
  noNameProduct: 'منتج بدون اسم',
  skuLabel: 'SKU',
  skuNotSpecified: 'غير محدد',
  categoryLabel: 'الفئة',
  subcategoryLabel: 'الفئة الفرعية',
  typeLabel: 'النوع',
  priceLabel: 'السعر',
  validationErrors: 'أخطاء التحقق',
  warnings: 'تحذيرات',
  editProductTitle: 'تعديل المنتج',
  productNameLabel: 'اسم المنتج',
  unitLabel: 'الوحدة',
  unitPriceLabel: 'سعر الوحدة',
  sellingPriceLabel: 'سعر البيع',
  cancel: 'إلغاء',
  save: 'حفظ',
  editBtn: 'تعديل',
  deleteBtn: 'حذف',
  skipBtn: 'تخطي',
  validating: 'جاري التحقق...',
  finishBtn: 'إنهاء',
  skipAllInvalid: 'تخطي جميع المنتجات غير الصالحة'
};
